import { LoginComponent } from './login/login.component';
import { RecoveryPasswordComponent } from './recovery-password/recovery-password.component';
import { LayoutComponent } from './content/layout/layout.component';
import { DashboardComponent } from './content/dashboard/dashboard.component';
import { ClientProfileComponent } from './client-profile/client-profile.component';
import { DevicesComponent } from './content/devices/devices.component';
import { DeviceFormComponent } from './content/devices/device-form/device-form.component';
import { Routes } from '@angular/router';
import { NewDeviceComponent } from './content/devices/new-device/new-device.component';
import { UsersComponent } from './users/users.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { RequestsComponent } from './content/devices/requests/requests.component';
import { DriversComponent } from './content/drivers/drivers.component';
import { GroupsComponent } from './content/devices/groups/groups.component';
import { GroupAssignmentComponent } from './movements/group-assignment/group-assignment.component';
import { DriverAssignmentComponent } from './movements/driver-assignment/driver-assignment.component';
import { StationAssignmentComponent } from './movements/station-assignment/station-assignment.component';
import { AccountStatementComponent } from './content/reports/account-statement/account-statement.component';
import { ConsumptionsComponent } from './content/reports/consumptions/consumptions.component';
import { QRcodeComponent } from './movements/qrcode/qrcode.component';
import { QRViewerComponent } from './movements/qrviewer/qrviewer.component';
import { ChartsComponent } from './content/reports/charts/charts.component';
import { LogsComponent } from './content/reports/logs/logs.component';
import { PaymentsComponent } from './content/payments/payments.component';
import { PaymentComponent } from './content/payments/payment/payment.component';
import { ContactComponent } from './content/help/contact/contact.component';
import { VideosComponent } from './content/help/videos/videos.component';
import { InvoicingComponent } from './content/invoicing/invoicing.component';
import { UpdateExpiratedPasswordComponent } from './update-expirated-password/update-expirated-password.component';
import { NotfoundComponent } from './utils/notfound/notfound.component';
import { AuthGuard } from './guards/auth.guard';
import { ErrorPageComponent } from './utils/error-page/error-page.component';
import { CanAccess } from './guards/can-access.guard';
import { Admin } from './guards/admin.guard';
import { ComplementsComponent } from './content/payments/complements/complements.component';
import { PaymentResponseComponent } from './payment-response/payment-response.component';
import { BalanceComponent } from './content/reports/balance/balance.component';
import { Balance } from './guards/balance.guard';

import { BlockRequestComponent } from './block-request/block-request.component';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { ActivateDriverComponent } from './activate-driver/activate-driver.component';
import { ComissionInvoiceComponent } from './content/reports/comission-invoice/comission-invoice.component';
import { QrsComponent } from './content/reports/qrs/qrs.component';
import { MobileDevicesComponent } from './content/mobile-devices/mobile-devices.component';
import { UnlinkDeviceComponent } from './unlink-device/unlink-device.component';
import { authGuardInvoiceGuard } from './guards/auth-guard-invoice.guard';

export const routes: Routes = [
    {
        path: '', pathMatch: 'full',
        component: LoginComponent
    },
    { path: 'login', component: LoginComponent },
    { path: 'recuperar', component: RecoveryPasswordComponent },
    { path: 'definir-contrasena/:token', loadComponent: () => import('./set-password/set-password.component').then(m => m.SetPasswordComponent) },
    { path: 'restablecer-contrasena/:token', loadComponent: () => import('./set-password/set-password.component').then(m => m.SetPasswordComponent) },
    { path: 'visualizacion_qr', component: QRViewerComponent },
    { path: 'bloquea/cuenta', component: BlockRequestComponent },
    { path: 'activa/usuario', component: ActivateUserComponent },
    { path: 'activa/conductor', component: ActivateDriverComponent },
     { path: 'desvincula/dispositivo', component: UnlinkDeviceComponent },
    { path: 'error', component: ErrorPageComponent },
    {
        path: 'app',
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
            {
                path: 'dashboard', pathMatch: 'full',
                component: DashboardComponent
            },
            {
                path: 'perfil', pathMatch: 'full',

                component: ClientProfileComponent
            },

            {
                canActivate: [Admin],
                path: 'dispositivos/vinculados', pathMatch: 'full',
                component: MobileDevicesComponent
            },
             {
                canActivate: [CanAccess],
                path: 'dispositivos', pathMatch: 'full',
                component: DevicesComponent
            },
            {
                canActivate: [CanAccess],
                path: 'dispositivo/:cardNumber',
                component: DeviceFormComponent
            },
            {
                path: 'agregar/dispositivo',
                canActivate: [Admin],
                component: NewDeviceComponent
            },
            {
                canActivate: [CanAccess],
                path: 'usuarios',
                component: UsersComponent
            },
            {
                canActivate: [CanAccess],
                path: 'restaurar/acceso',
                component: ChangePasswordComponent
            },
            {
                canActivate: [CanAccess],
                path: 'dispositivos/solicitudes',
                component: RequestsComponent
            },
            {
                canActivate: [CanAccess],
                path: 'dispositivos/grupos',
                component: GroupsComponent
            },
            {
                canActivate: [CanAccess],
                path: 'conductores',
                component: DriversComponent
            },
            {
                canActivate: [CanAccess],
                path: 'grupos/asignacion',
                component: GroupAssignmentComponent
            },
            {
                canActivate: [CanAccess],
                path: 'conductores/asignacion',
                component: DriverAssignmentComponent
            },
            {
                canActivate: [CanAccess],
                path: 'estaciones/asignacion',
                component: StationAssignmentComponent
            },
            {

                path: 'reportes/facturas/comision',
                component: ComissionInvoiceComponent
            },

            {

                path: 'reportes/estado_cuenta',
                component: AccountStatementComponent
            },
            {
                path: 'reportes/consumos',
                component: ConsumptionsComponent
            },
             {
                path: 'reportes/qrs_generados',
                component: QrsComponent
            },
            {
                canActivate: [Balance],
                path: 'reportes/balance',
                component: BalanceComponent
            },
            {
                canActivate: [Admin],
                path: 'generar_qr',
                component: QRcodeComponent
            },

            {
                path: 'reportes/grafica/consumos',
                component: ChartsComponent
            },
            {
                canActivate: [CanAccess],
                path: 'bitacora',
                component: LogsComponent
            },
            {

                path: 'pagos',
                component: PaymentsComponent
            },
            {

                path: 'pagos/complementos',
                component: ComplementsComponent
            },
            {
                canActivate: [Admin],
                path: 'pagos/pago',
                component: PaymentComponent
            },
            {
                canActivate: [CanAccess],
                path: 'ayuda/contacto',
                component: ContactComponent
            },
            {
                canActivate: [CanAccess],
                path: 'ayuda/tutoriales',
                component: VideosComponent
            },
            {
                canActivate: [authGuardInvoiceGuard],
                path: 'facturacion',
                component: InvoicingComponent
            }
        ]


    },
    { path: 'pago/respuesta', component: PaymentResponseComponent },
    {
        path: 'consumo/web', component: QRViewerComponent,
    },

    {
        path: '**', pathMatch: 'full',
        component: NotfoundComponent
    }



];
